import { observePageVisibility } from './page-visibility';
import { observePageClicks } from './page-clicks';
export { observePageVisibility, observePageClicks };